<script>
import { mapGetters } from 'vuex'
import { useCases } from 'frontend-js-shared'

export default {
  computed: {
    ...mapGetters(['account', 'organizationSiteGroups']),
  },

  methods: {
    getChallengePermissions({ challenge } = {}) {
      return useCases.challenges.getPermissions({
        currentAccount: this.account,
        challenge,
        organizationSiteGroups: this.organizationSiteGroups,
      })
    },
    canEditChallenge(challenge) {
      return this.getChallengePermissions({ challenge }).edit
    },
    canDeleteChallenge(challenge) {
      return this.getChallengePermissions({ challenge }).delete
    },
    canCreateChallenges() {
      return this.getChallengePermissions().create
    },
  },
}
</script>
